// extracted by mini-css-extract-plugin
module.exports = {"root":"home-module--root--2VXeW","homeText":"home-module--homeText--3crpt","homeHero":"home-module--homeHero--1heIj"};